var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgresscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM2.24052 13C2.24052 18.9423 7.0577 23.7595 13 23.7595C18.9423 23.7595 23.7595 18.9423 23.7595 13C23.7595 7.0577 18.9423 2.24052 13 2.24052C7.0577 2.24052 2.24052 7.0577 2.24052 13Z",
    fill: "#EAF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8797 13C25.4984 13 26.005 13.5025 25.9518 14.1189C25.7638 16.2954 25.0295 18.396 23.8091 20.2224C22.3806 22.3603 20.3503 24.0265 17.9749 25.0104C15.5994 25.9944 12.9856 26.2518 10.4638 25.7502C7.94207 25.2486 5.62569 24.0105 3.80761 22.1924C1.98953 20.3743 0.751399 18.0579 0.249791 15.5362C-0.251817 13.0144 0.00562687 10.4006 0.989566 8.02512C1.97351 5.64968 3.63975 3.61935 5.77759 2.1909C7.60402 0.970511 9.70459 0.23625 11.8811 0.0482339C12.4975 -0.0050141 13 0.501556 13 1.12026C13 1.73896 12.4971 2.23448 11.8817 2.29878C10.149 2.47984 8.48017 3.07973 7.02235 4.05382C5.25296 5.23608 3.87389 6.91648 3.05953 8.88252C2.24517 10.8486 2.0321 13.0119 2.44726 15.0991C2.86241 17.1862 3.88715 19.1034 5.3919 20.6081C6.89664 22.1128 8.81379 23.1376 10.9009 23.5527C12.9881 23.9679 15.1514 23.7548 17.1175 22.9405C19.0835 22.1261 20.7639 20.747 21.9462 18.9776C22.9203 17.5198 23.5202 15.851 23.7012 14.1183C23.7655 13.5029 24.261 13 24.8797 13Z",
    fill: "#407EC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgresscircle);
export default __webpack_public_path__ + "static/media/progress circle.955f3f7b1d4ec408e0be0f5352215b47.svg";
export { ForwardRef as ReactComponent };